import clsx from "clsx";

const VARIANT_MAP = {
  success: "bg-green-100 text-green-800 border-green-200",
  warning: "bg-yellow-100 text-yellow-800 border-yellow-200",
  error: "bg-red-100 text-red-800 border-red-200",
  info: "bg-blue-100 text-blue-800 border-blue-200",
  default: "bg-gray-100 text-gray-800 border-gray-200",
  primary: "bg-primary/10 text-primary border-primary/20",
  secondary: "bg-secondary/10 text-secondary border-secondary/20",
};

const SIZE_MAP = {
  small: "text-xs px-2 py-0.5",
  medium: "text-sm px-3 py-1",
  large: "text-base px-4 py-1.5",
};

export default function Badge({
  label,
  children,
  variant = "default",
  size = "small",
  className = "",
  ...rest
}) {
  return (
    <span
      className={clsx(
        "inline-flex items-center font-semibold rounded-full border",
        VARIANT_MAP[variant] || VARIANT_MAP.default,
        SIZE_MAP[size] || SIZE_MAP.small,
        className
      )}
      {...rest}
    >
      {label || children}
    </span>
  );
}
